import RequestOtpForm from '@/components/forms/RequestOtpForm';
import VerifyOtpForm from '@/components/forms/VerifyOtpForm';
import Modal from '@/components/modals/Modal';
import { logInModalI18n } from '@/i18n/shared/LogInModal.i18n';
import { otpModalI18n } from '@/i18n/shared/OtpModal.i18n';
import { useState } from 'react';

type Props = {
  onClose: () => void;
};

export default function LogInModal({ onClose }: Props) {
  const [otpHasBeenSentTo, setOtpHasBeenSentTo] = useState<string | null>(null);

  return (
    <Modal
      onClose={onClose}
      closeOnOverlayClick={false}
      title={logInModalI18n.title.en}
    >
      {otpHasBeenSentTo === null ? (
        <div className="flex flex-col space-y-5">
          <RequestOtpForm
            submitButtonText={'Log In'}
            onSuccess={(email: string) => setOtpHasBeenSentTo(email)}
          />
        </div>
      ) : (
        <div className="space-y-5">
          <h2>{otpModalI18n.title.en}</h2>
          <p>{otpModalI18n.explanation.en}</p>

          <VerifyOtpForm email={otpHasBeenSentTo} />
        </div>
      )}
    </Modal>
  );
}
